// notes endpoints
export const API_ENDPOINT_ALL_NOTES = "/tasks";
export const API_ENDPOINT_ADD_NOTE = "/task";
export const API_ENDPOINT_UPDATE_NOTE = "/task";
export const API_ENDPOINT_DELETE_TASK = "/task";

// links endpoints
export const API_ENDPOINT_ALL_LINKS = "/links";
export const API_ENDPOINT_ADD_LINK = "/link";
export const API_ENDPOINT_DELETE_LINK = "/link";

export const API_ENDPOINT_ALL_RECURRING_TRANSACTIONS =
  "/recurring-transactions";
export const API_ENDPOINT_ADD_RECURRING_TRANSACTION = "/recurring-transaction";
export const API_ENDPOINT_DELETE_RECURRING_TRANSACTION =
  "/recurring-transactions";
export const API_ENDPOINT_UPDATE_RECURRING_TRANSACTION =
  "/recurring-transaction";

// transactions endpoints
export const API_ENDPOINT_ALL_INVOICES = "/invoices";
export const API_ENDPOINT_ADD_INVOICE = "/invoice";
export const API_ENDPOINT_UPDATE_INVOICE = "/invoice";
export const API_ENDPOINT_UPDATE_TRANSACTION = "/transaction-text-update";
export const API_ENDPOINT_UPDATE_TRANSACTIONS_ACCOUNT =
  "/update-transactions-account";
export const API_ENDPOINT_PAY_RECURRING_TRANSACTION = "/invoice/from-recurring";

export const API_ENDPOINT_DELETE_INVOICE = "/invoice";
export const API_ENDPOINT_GET_INVOICE = "/invoice";
export const API_ENDPOINT_CLONE_TRANSACTION = "/clone/transaction";

// auth endpoints
export const API_ENDPOINT_LOGIN = "/login";
export const API_ENDPOINT_REGISTER = "/register";

// profile
export const API_ENDPOINT_UPDATE_PROFILE = "/user";

// account endpoints
export const API_ENDPOINT_ALL_ACCOUNTS = "/accounts";
export const API_ENDPOINT_ADD_ACCOUNT = "/account";
export const API_ENDPOINT_UPDATE_ACCOUNT = "/account";
export const API_ENDPOINT_DELETE_ACCOUNT = "/account";
export const API_ENDPOINT_GET_ACCOUNT = "/account";
export const API_ENDPOINT_UPLOAD_ATTACHMENT = "/upload";

// google endpoints
export const API_ENDPOINT_GOOGLE_EXCHANGE_TOKENS = "/auth/google/exchange-code";
export const API_ENDPOINT_GOOGLE_SEND_EMAIL = "/integrations/gmail/send";
export const API_ENDPOINT_GOOGLE_SEND_RECEIPT_EMAIL =
  "/integrations/gmail/send-receipt";
export const API_ENDPOINT_GOOGLE_SEND_INVITE_EMAIL =
  "/integrations/gmail/send-invite";

// openai
export const API_ENDPOINT_OPENAI_PARSE_RECEIPT =
  "/integrations/openai/parse-receipt";

// categories endpoints
export const API_ENDPOINT_ALL_CATEGORIES = "/categories";
export const API_ENDPOINT_ADD_CATEGORY = "/category";
export const API_ENDPOINT_GET_CATEGORY = "/category";

export const API_ENDPOINT_ALL_SOURCES = "/sources";
export const API_ENDPOINT_ADD_SOURCE = "/source";

export const API_ENDPOINT_ALL_LOANS = "/loans";

export const API_ENDPOINT_SEARCH_NETWORK = "/search-network";
export const API_ENDPOINT_SEND_INVITE = "/invite";
export const API_ENDPOINT_GET_INVITES = "/invites";

export const API_ENDPOINT_PARSE_XML = "/parser/xml";

export const API_ENDPOINT_DELETE_INVITE = "/invite";
export const API_ENDPOINT_ACCEPT_INVITE = "/accept-invite";

export const API_ENDPOINT_GET_USERS = "/users";
